export enum SavedSearchType {
    MONITORING = 'MONITORING',
    ALERT = 'ALERT',
    BRIEFING = 'BRIEFING',
    REPORTS = 'REPORTING',
    /** Filters owned by an automation agent - kept out of the topic lists, which only read MONITORING */
    AGENT = 'AGENT'
}
